import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Dashboard } from '@components/common';
import { useAppearance } from '@fourthwall/appearance';
import { Toasts, useCopyToClipboard } from '@fourthwall/components';
import { Stat, StatGroup } from '@fourthwall/module-analytics';
import { ShopUrlActionsDesktop } from '@fourthwall/module-shop-status-switch';
import { routing } from '@utils/routing';
import { useCurrentShop } from '../../../hooks/useCurrentShop';
import { ActiveVisitors } from '../ActiveVisitors';
import { AnalyticsDropdown } from './components/AnalyticsDropdown';
import { useHomeAnalytics } from './hooks/useHomeAnalytics';
import * as S from './styled';
export const HomeAnalytics = () => {
    const { appearance } = useAppearance();
    const { tabs, stats } = useHomeAnalytics();
    const { copyToClipboard } = useCopyToClipboard();
    const navigate = useNavigate();
    const { currentShopQuery } = useCurrentShop();
    return (React.createElement(S.Container, { "data-analytics-section": "home-analytics" },
        React.createElement(S.TopBar, null,
            React.createElement(S.TopBarLeftContent, null,
                React.createElement(AnalyticsDropdown, { tabs: tabs }),
                React.createElement(ActiveVisitors, null)),
            React.createElement(ShopUrlActionsDesktop, { size: "small", onDuplicateClick: () => {
                    copyToClipboard(currentShopQuery.data?.baseUri || '');
                    Toasts.notify('Copied to clipboard', { type: 'info' });
                }, onSettingsClick: () => {
                    navigate(routing.settings.domain.self);
                } })),
        React.createElement(Dashboard.Section.ScrollableContent, { hideScrollbar: true, fullWidth: true },
            React.createElement(StatGroup, null, stats.map((props, index) => (React.createElement(S.StatWrapper, { key: index },
                React.createElement(Stat, { ...props, appearance: appearance }))))))));
};
